var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.isShow,
          expression: "isShow"
        }
      ],
      ref: "checkApple",
      staticClass: "content",
      attrs: { id: "checkApple" }
    },
    [
      _c("div", { staticClass: "title" }, [
        _c("span", [
          _vm._v(_vm._s(_vm.$t("language.popup.checkApplePopup.title")))
        ]),
        _vm._v(" "),
        _c("div", {
          staticClass: "icon white-close dialog-close",
          on: {
            click: function($event) {
              return _vm.close()
            }
          }
        })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "content-body" }, [
        _c("div", { staticClass: "popup-title-tips" }, [
          _vm._v(
            "\r\n            " +
              _vm._s(_vm.$t("language.popup.checkApplePopup.tip1")) +
              "\r\n        "
          )
        ]),
        _vm._v(" "),
        _c(
          "div",
          {},
          [
            _c("codeInput", {
              ref: "codeInput",
              attrs: { len: 6, singleRule: "num" }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            on: {
              click: function($event) {
                return _vm.submitOk()
              }
            }
          },
          [
            _c(
              "span",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.$parent.connect,
                    expression: "!$parent.connect"
                  }
                ],
                staticClass: "button-tip"
              },
              [_vm._v(_vm._s(_vm.$t("language.common.ok")))]
            ),
            _vm._v(" "),
            _c(
              "span",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.$parent.connect,
                    expression: "$parent.connect"
                  }
                ],
                staticClass: "button-tip"
              },
              [
                _vm._v(
                  "\r\n                " +
                    _vm._s(_vm.$t("language.common.connecting")) +
                    "\r\n                "
                ),
                _c("span", { staticClass: "cloudDotting" })
              ]
            )
          ]
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-dc3c95fa", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dc3c95fa","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/popup/add_cloud_popups/check_apple_popup.vue
// module id = null
// module chunks = 